import icons from './icons';
import replace from './replace';
import toSvg from './to-svg';

module.exports = { icons, replace, toSvg };
